/// format date to Jun 1, 2024, 6:00 AM
export function formatDate(date: Date) {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
}

/// format date to 2023-06-13
export function formatDateNumeric(date: Date) {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    formatMatcher: "basic",
  };
  return date
    .toLocaleDateString("en-US", options)
    .split("/")
    .reverse()
    .join("-");
}

// format to 12 Jun 2024
export function formatDateToDDMMMMYYYY(date: Date) {
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

// format date to 12 Jun’ 24
export function formatDateShort(date: Date) {
  return (
    date.toLocaleDateString("en-US", {
      day: "numeric",
    }) +
    " " +
    date.toLocaleDateString("en-US", {
      month: "short",
    }) +
    "’ " +
    date.toLocaleDateString("en-US", {
      year: "2-digit",
    })
  );
}

// format date to 12 Jun’ 24 · 4:00 PM
export function formateDateShortWithTime(date: Date) {
  return (
    formatDateShort(date) +
    " · " +
    date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    })
  );
}

// format date to 24 July 2025
export function formatDateLong(date: Date) {
  return (
    date.toLocaleDateString("en-US", {
      day: "numeric",
    }) +
    " " +
    date.toLocaleDateString("en-US", {
      month: "long",
    }) +
    " " +
    date.toLocaleDateString("en-US", {
      year: "numeric",
    })
  );
}

// format date to 24 July 2025 · 4:00 PM
export function formatDateLongWithTime(date: Date) {
  return (
    formatDateLong(date) +
    " · " +
    date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    })
  );
}

export function convertDateFormatFromYYYYMMDDToDDMMYYYY(dateString: string) {
  const [year, month, day] = dateString.split("-");
  return `${day}/${month}/${year}`;
}

export function getCurrentYear() {
  return new Date().getFullYear();
}

// format date to 1st, 2nd, 3rd, 4th
export const getOrdinalDay = (date: Date): string => {
  const day = date.getDate();
  if (day < 1 || day > 31) {
    throw new Error("Day must be between 1 and 31");
  }

  if (day >= 11 && day <= 13) {
    return `${day}th`;
  }

  const lastDigit = day % 10;

  switch (lastDigit) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
};

export const getConsistentDay = (date: Date): Date => {
  const newDate = new Date(date);
  const day = date.getDate();

  // Convert 31st to 30th
  if (day === 31) {
    newDate.setDate(30);
  }

  return newDate;
};
